import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Estado global para la gestión de filtros y exportación de reportes dinámicos.
 */
interface ReportExportState {
  reportCode: string;            // Código del reporte seleccionado
  filters: Record<string, any>;   // Filtros dinámicos aplicados
}

/**
 * Estado inicial de la exportación de reportes.
 */
const initialState: ReportExportState = {
  reportCode: '',       // No hay reporte seleccionado al inicio
  filters: {},          // No hay filtros aplicados al inicio
};

/**
 * Slice de Redux Toolkit para manejar filtros y exportación de reportes.
 */
const reportExportSlice = createSlice({
  name: 'reportExport',
  initialState,
  reducers: {
    /**
     * Actualiza el código del reporte seleccionado.
     */
    setReportCode(state, action: PayloadAction<string>) {
      state.reportCode = action.payload;
    },

    /**
     * Actualiza los filtros dinámicos.
     */
    setFilters(state, action: PayloadAction<Record<string, any>>) {
      state.filters = action.payload;
    },

    /**
     * Limpia los filtros y código de reporte seleccionados.
     */
    resetReportExportState(state) {
      state.reportCode = '';
      state.filters = {};
    },

  },
});

// Exportación de acciones
export const {
  setReportCode,
  setFilters,
  resetReportExportState,
} = reportExportSlice.actions;

// Exportación del reducer
export default reportExportSlice.reducer;
